import styled from 'styled-components';
const dataBack = require('@/assets/img/coupon_setting_data.png');
const initBack = require('@/assets/img/coupon_setting_nodata.png');

export default styled.div`
  height: 100%;
  overflow: hidden;
  form {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 60px;
    .prize-wrap {
      height: 100%;
      flex-shrink: 1;
      display: flex;
      gap: 48px;
      overflow: auto;
      .left-content {
        width: 800px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        flex-shrink: 0;
        .prize-content-wrap {
          width: 100%;
          max-height: 444px;
          border-radius: 34px;
          padding-top: 16px;
          padding-right: 24px;
          padding-bottom: 16px;
          padding-left: 18px;
          border: 1px solid #e5e5e5;
          background: #ffffff;
          &.prize-content-wrap-undo {
            border: 1px solid #ffe2e2;
            background: #fff8f8;
          }
          .prize-content-top {
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
              display: flex;
              align-items: center;
              gap: 16px;
              .left-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 32px;
                width: 32px;
                border-radius: 16px;
                background-color: #c8e0ff;
                cursor: pointer;
                &.left-icon-close {
                  transform: rotateX(180deg);
                }
                &.left-undo {
                  background-color: #ffe2e2;
                }
              }
              .left-name {
                font-size: 17px;
                color: #333;
                font-weight: 500;
              }
            }
            .right {
              width: 103px;
              height: 36px;
              border-radius: 20px;
              padding-top: 8px;
              padding-right: 12px;
              padding-bottom: 8px;
              padding-left: 8px;
              border: 1px solid #c8e0ff;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #1565c0;
              font-size: 14px;
              font-weight: 500;
              gap: 0 4px;
              &.undo {
                border: 1px solid #ffe2e2;
                color: #ff7272;
              }
            }
          }
          .prize-content-bottom {
            margin-top: 24px;
            display: flex;
            flex-direction: column;
            gap: 24px;
            &.prize-content-bottom-close {
              display: none;
            }
            .prize-content-bottom-line {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            .coupon-card-wrap {
              display: flex;
              align-items: center;
              gap: 0 16px;
              .card-item {
                width: 382px;
                height: 140px;
                display: flex;
                padding: 24px;
                padding-right: 10px;
                background: url(${dataBack}) 0 0 no-repeat;
                background-size: cover;
                &.card-item-no-data {
                  background: url(${initBack}) 0 0 no-repeat;
                }
                .card-item-wrap {
                  width: 238px;
                  height: 100%;
                  display: flex;
                  justify-content: space-between;
                  flex-direction: column;
                  .card-item-name {
                    color: #1565c0;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 22px;
                  }
                }
              }
              .card-item-info-1 {
                font-size: 12px;
                font-weight: 400;
                line-height: 22px;
                color: #bdc0c4;
              }
              .card-item-info-2 {
                display: flex;
                align-items: center;
                color: #424242;
                gap: 0 2px;
              }
              .card-item-info-3 {
                font-size: 16px;
                font-weight: 600;
                line-height: 22px;
              }
              .card-item-info-4 {
                font-size: 12px;
                font-weight: 400;
                line-height: 14px;
                transform: scale(0.83);
              }
              .card-item-info-5 {
                flex: 1;
                height: 100%;
                padding-left: 35px;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
              }
              .card-item-info-6 {
                font-size: 12px;
                font-weight: 400;
                line-height: 22px;
                color: #bdc0c4;
              }
              .card-item-info-7 {
                display: flex;
                align-items: center;
                color: #424242;
                gap: 0 2px;
              }
              .card-item-info-8 {
                fontsize: 19.2px;
                font-weight: 600;
                line-height: 22px;
                transform: scale(0.83);
                margin-left: -4px;
              }
              .card-item-info-9 {
                fontsize: 19.2px;
                font-weight: 600;
                line-height: 22px;
                transform: scale(0.83);
                margin-left: -4px;
              }
            }
          }
        }
      }
      .right-content {
        display: flex;
        flex-direction: column;
        gap: 24px;
        width: 100%;
        flex-shrink: 1;
        padding-right: 5px;
      }
    }
  }
  .required-star {
    color: #d10000;
    display: inline-block;
    width: 7px;
    fontsize: 12px;
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
`;
